export default __webpack_public_path__ + "static/media/HomeBottomnav.da0879fc.svg";